export default "__VITE_ASSET__CpmhKzEB__"